<template>
    <svg viewBox="0 0 33 53" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16.8498 0.666687L16.4974 1.85009V36.1896L16.8498 36.5371L32.9842 27.115L16.8498 0.666687Z"
            fill="#8247E5"
        />
        <path
            d="M16.85 0.666687L0.715599 27.115L16.85 36.5372V19.8699V0.666687Z"
            fill="#B591F0"
        />
        <path
            d="M16.8497 39.5552L16.6511 39.7944V52.0268L16.8497 52.6L32.9937 30.1378L16.8497 39.5552Z"
            fill="#8247E5"
        />
        <path
            d="M16.85 52.5998V39.5551L0.715599 30.1377L16.85 52.5998Z"
            fill="#B591F0"
        />
        <path
            d="M16.8497 36.537L32.9838 27.1151L16.8497 19.8699V36.537Z"
            fill="#3C1281"
        />
        <path
            d="M0.715599 27.1151L16.8497 36.537V19.8699L0.715599 27.1151Z"
            fill="#8247E5"
        />
    </svg>
</template>
